export type { IAnimationStyles, IAnimationVariables } from './IAnimationStyles';
export type { IEffects } from '@fluentui/theme/lib/types/IEffects';
export type { IGetFocusStylesOptions } from './IGetFocusStyles';
export type { IFontStyles } from '@fluentui/theme/lib/types/IFontStyles';
export type { IPalette } from '@fluentui/theme/lib/types/IPalette';
export type { ISemanticColors } from '@fluentui/theme/lib/types/ISemanticColors';
export type { ISemanticTextColors } from '@fluentui/theme/lib/types/ISemanticTextColors';
export type { ISpacing } from '@fluentui/theme/lib/types/ISpacing';
export type { ITheme, IPartialTheme, IScheme, ISchemeNames } from '@fluentui/theme/lib/types/ITheme';
